import type { DashboardLayout } from './types'

export const EmptyDashboardLayout: DashboardLayout = {
    id: '00000000-0000-0000-0000-000000000000',
    version: 1,
    name: 'Dashboard',
    cards: [],
}
